import { createContext, useContext, useState, useEffect, useRef, useCallback } from "react";
import { api } from "./api";

const CartCtx = createContext(null);

function newCartId() {
  return "cart_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function CartProvider({ children }) {
  const [cartId] = useState(() => {
    let id = localStorage.getItem("dcc_cart_id");
    if (!id) {
      id = newCartId();
      localStorage.setItem("dcc_cart_id", id);
    }
    return id;
  });
  const [items, setItems] = useState([]);
  const syncTimer = useRef(null);

  useEffect(() => {
    api.get(`/public/cart/${cartId}`).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, [cartId]);

  const persist = useCallback((next) => {
    setItems(next);
    clearTimeout(syncTimer.current);
    syncTimer.current = setTimeout(() => {
      api.put(`/public/cart/${cartId}`, { items: next }).catch(() => {});
    }, 400);
  }, [cartId]);

  const addItem = (product, variant = "") => {
    const key = product.product_id + "|" + variant;
    const existing = items.find((i) => i.key === key);
    const next = existing
      ? items.map((i) => (i.key === key ? { ...i, qty: i.qty + 1 } : i))
      : [...items, {
          key, product_id: product.product_id, title: product.title,
          subtitle: product.subtitle || "", variant, qty: 1,
          price: product.price || "", image: product.image || "",
        }];
    persist(next);
  };
  const removeItem = (key) => persist(items.filter((i) => i.key !== key));
  const setQty = (key, qty) => {
    if (qty < 1) return removeItem(key);
    persist(items.map((i) => (i.key === key ? { ...i, qty } : i)));
  };
  const clear = () => persist([]);
  const count = items.reduce((n, i) => n + i.qty, 0);

  return (
    <CartCtx.Provider value={{ items, count, addItem, removeItem, setQty, clear }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
